import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

export const TestimonialCard = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 5;
  @media screen and (max-width: 1000px) {
    grid-column: 1/-1;
  }
`
export const KeyLine = styled.span`
  display: block;
  height: 3px;
  width: 25px;
  border-radius: 10px;
  margin-bottom: 60px;
  background-color: ${({ theme }) => theme.colors.accentBlue};
  @media screen and (max-width: 760px) {
    margin-bottom: 40px;
  }
`

export const ImageContainer = styled.div`
  width: 150px;
  height: 95px;
  position: relative;
  @media screen and (max-width: 760px) {
    height: 75px;
  }
`
export const TestimonialImage = styled(GatsbyImage)`
  max-height: 75px;
  max-width: 75px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
  img {
    border-radius: 50%;
  }
`
export const CompanyImageContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  height: 75px;
  width: 75px;
  box-shadow: 2px 4px 15px 0 rgba(19, 15, 235, 0.1);
  background-color: #fff;
  border-radius: 50%;
  @media screen and (max-width: 760px) {
    top: 0px;
    right: 15px;
  }
`
export const CompanyImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65px;
`

const textStyling = css`
  text-align: left;
  color: ${({ theme: { colors } }) => colors.black};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  font-size: 20px;
  line-height: 30px;
  @media screen and (max-width: 760px) {
    font-size: 18px;
    line-height: 28px;
  }
`

export const TestimonialName = styled.h4`
  ${textStyling};
  margin-top: 20px;
`

export const TestimonialHiredAt = styled.span`
  ${textStyling}
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  color: ${({ theme: { colors } }) => colors.darkGrey};
`

export const TestimonialStatement = styled.div`
  ${textStyling};
  a {
    color: ${({ theme: { colors } }) => colors.hyperLinkPink};
  }
  margin-top: 15px;
`
